// Maximum uploaded file size in megabytes - kept in sync with backend
// app/constants.py:MAX_DOCUMENT_SIZE_MB
export const MAX_DOCUMENT_SIZE_MB = 100;
export const MAX_DOCUMENT_SIZE_BYTES = MAX_DOCUMENT_SIZE_MB * 1024 * 1024;

// Kept in sync with outreach app/inbox/attachments.py:MAX_ATTACHMENT_TOTAL_BYTES.
export const MAX_REPLY_ATTACHMENT_MB = 15;
export const MAX_REPLY_ATTACHMENT_BYTES = MAX_REPLY_ATTACHMENT_MB * 1024 * 1024;
